import React from 'react';
import PropTypes from 'prop-types';

import withModal from '../modal/withModal';
import UserAddressForm from './UserAddressForm';
import { USER_ADDRESS_MODAL } from '../../../constants/modals';

const propTypes = {
  actionProps: PropTypes.shape({
    address: PropTypes.shape({
      id: PropTypes.string,
    }),
    defaultName: PropTypes.string,
  }),
};
const UserAddressFormModal = ({ actionProps, ...props }) => {
  const { address, defaultName } = actionProps ?? {};

  return (
    <UserAddressForm address={address} defaultName={defaultName} {...props} />
  );
};

UserAddressFormModal.propTypes = propTypes;

export default withModal(UserAddressFormModal, {
  name: USER_ADDRESS_MODAL,
  size: 'sm',
  hideHeader: true,
  dismissible: false,
  overlayClassName: 'z-modal-max',
});
